"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
var _permission = require("@/utils/permission");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------

// 权限判断函数
var signObj = {
  day: 0,
  experience: 0,
  integral: 0,
  id: 0,
  isExperience: true,
  isIntegral: true,
  show: true
};
var _default = exports.default = {
  name: 'index',
  data: function data() {
    return {
      signForm: {
        day: 0,
        experience: 0,
        id: 0,
        integral: 0,
        isExperience: true,
        isIntegral: true,
        signRuleDescription: ''
      },
      defaultDescription: '1.每天签到可以获得每天签到奖励',
      rules: {
        isIntegral: [{
          required: true,
          message: '请输入积分值',
          trigger: 'blur'
        }],
        experience: [{
          required: true,
          message: '请输入经验值',
          trigger: 'blur'
        }]
      },
      signConfigList: [],
      showTab: false
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:sign:get:config'])) this.getSignConfig();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    getSignConfig: function getSignConfig() {
      var _this = this;
      (0, _marketing.signeGetConfigApi)().then(function (res) {
        _this.signForm = res.baseSignConfig;
        _this.$set(_this, 'signConfigList', res.signConfigList);
        _this.$set(_this.signForm, 'signRuleDescription', res.signRuleDescription);
      });
    },
    submitForm: (0, _validate.Debounce)(function (formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          (0, _marketing.signBaseConfigApi)(_this2.signForm).then(function () {
            _this2.$message.success('操作成功');
            _this2.getSignConfig();
          });
        } else {
          return false;
        }
      });
    }),
    addSign: function addSign() {
      this.signConfigList.push(Object.assign({}, signObj));
    },
    editSign: function editSign(row) {
      this.$set(row, 'show', true);
    },
    delSign: function delSign(row) {
      var _this3 = this;
      this.$modalSure('删除当前数据?').then(function () {
        (0, _marketing.signeDelConfigApi)(row.id).then(function (data) {
          _this3.$message.success('删除成功');
          _this3.getSignConfig();
        });
      });
    },
    saveSign: function saveSign(row) {
      var _this4 = this;
      row.id ? (0, _marketing.signeEditConfigApi)(row).then(function () {
        _this4.$set(row, 'show', false);
        _this4.$message.success('操作成功');
        _this4.getSignConfig();
      }) : (0, _marketing.signAddConfigApi)(row).then(function () {
        _this4.$set(row, 'show', false);
        _this4.$message.success('操作成功');
        _this4.getSignConfig();
      });
    }
  }
};